export const STATUSES = ["draft", "sent", "in_review", "resolved"];

export const nextStatus = (s) => {
  const i = STATUSES.indexOf(s);
  return i >= 0 && i < STATUSES.length - 1 ? STATUSES[i + 1] : null;
};

export const statusLabel = (s) => s.replace(/_/g, " ");

export const riskColor = (r) => {
  if (r === "high") return "bg-danger";
  if (r === "medium") return "bg-warn";
  return "bg-ok";
};
